"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NIFTRON = void 0;

var utils_1 = require("../utils");

var xdrBuilder_1 = require("../xdrBuilder");

var token_1 = require("../token");

var user_1 = require("../user");

var NIFTRON =
/** @class */
function () {
  function NIFTRON(niftronConfig) {
    var _this = this;

    this.user = user_1.User;
    this.xdrBuilder = xdrBuilder_1.XDRBuilder;
    this.utils = utils_1.Utils;
    this.tokenBuilder = token_1.TokenBuilder;

    if (niftronConfig.secretKey != undefined) {
      NIFTRON.secretKey = niftronConfig.secretKey;
    }

    if (niftronConfig.credential != undefined) {
      var niftronCredential = niftronConfig.credential;

      if (niftronCredential.type != "niftron") {
        throw new Error("only .niftron credential files are accepted");
      }

      var reader_1 = new FileReader();
      reader_1.addEventListener("load", function () {
        return __awaiter(_this, void 0, void 0, function () {
          return __generator(this, function (_a) {
            if (reader_1.result) {
              NIFTRON.secretKey = JSON.parse(atob(reader_1.result.toString())).secretKey;
            }

            return [2
            /*return*/
            ];
          });
        });
      });
      reader_1.readAsText(niftronCredential);
    }

    if (niftronConfig.secretKey != undefined && niftronConfig.credential != undefined) {
      throw new Error("please provide a secret key or .niftron credential file");
    }
  }
  /**
   * initializes niftron
   */


  NIFTRON.prototype.initialize = function () {
    try {
      if (NIFTRON.secretKey == null) {
        throw new Error("please provide a secret key or .niftron credential file");
      }

      NIFTRON.xdrBuilder.initialize(NIFTRON.secretKey);
      NIFTRON.tokenBuilder.initialize(NIFTRON.secretKey);
      NIFTRON.user.initialize(NIFTRON.secretKey);
      NIFTRON.isInitialized = true;
    } catch (err) {
      throw err;
    }
  };
  /**
   * returns secretKey
   * @returns {string} secretKey string
   */


  NIFTRON.prototype.getSecret = function () {
    try {
      if (NIFTRON.secretKey == null) {
        throw new Error("please provide a secret key or .niftron credential file");
      }

      if (!NIFTRON.isInitialized) {
        throw new Error("please initialize the config");
      }

      return NIFTRON.secretKey;
    } catch (err) {
      throw err;
    }
  };

  NIFTRON.isInitialized = false;
  NIFTRON.secretKey = null;
  return NIFTRON;
}();

exports.NIFTRON = NIFTRON;
/**
 * The main NIFTRON namespace
 */

(function (NIFTRON) {
  NIFTRON.utils = utils_1.Utils;
  NIFTRON.tokenBuilder = token_1.TokenBuilder;
  NIFTRON.xdrBuilder = xdrBuilder_1.XDRBuilder;
  NIFTRON.user = user_1.User;
})(NIFTRON = exports.NIFTRON || (exports.NIFTRON = {}));

exports.NIFTRON = NIFTRON;